import axios from "axios";
import config from "../config";

// default
axios.defaults.baseURL = config.API_URL;
const API_URL = config.API_URL;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axios.interceptors.response.use(function (response: any) {
  return response.data ? response.data : response;
});

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  _axios = axios.create({
    baseURL: API_URL,
    withCredentials: true,
  });

  constructor() {
    this._axios.interceptors.response.use(
      response => response,
      error => {
        if (
          error.response?.data?.message == "Token is not valid" ||
          error.response?.data?.message == "No token, authorization denied"
        ) {
          this.logout(); // Token expired or invalid
        }
        return Promise.reject(error);
      },
    );
  }

  logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userData");
    window.location.href = "/logout"; // Redirect to login
  };

  addRequestInterceptor = (onFulfilled: any, onRejected: any) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled: any, onRejected: any) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  // get = async (url: string, params?: Record<string, any>) =>
  //   this.request({ method: "get", url, params });

  get = async (
    url: string,
    params?: Record<string, any>,
    responseType: any = "json",
  ) => this.request({ method: "get", url, params, responseType });

  create = async (url: string, data: any) =>
    await this.request(this.getOptionsConfig("post", url, data));

  put = async (url: string, data: any) =>
    await this.request(this.getOptionsConfig("put", url, data));

  update = async (url: string, data: any) =>
    await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url: string, params?: Record<string, any>) =>
    this.request({ method: "delete", url, params });

  getOptionsConfig = (method: any, url: string, data?: any) => {
    const headers = { "Content-Type": "application/json" };

    // If data is FormData, let Axios automatically set the correct headers
    if (data instanceof FormData) {
      delete (headers as Record<string, string>)["Content-Type"];
    }

    return {
      method,
      url,
      data,
      headers,
    };
  };

  request(options: any) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then(res => {
          resolve(res.data);
        })
        .catch(ex => {
          reject(ex.response?.data || ex.message);
        });
    });
  }
}

class APIClientWithoutToken {
  _axios = axios.create({
    baseURL: API_URL,
  });

  send = async (url: string, data: any) =>
    await this.request(this.getOptionsConfig("post", url, data));

  getOptionsConfig = (method: any, url: string, data?: any) => {
    const headers = { "Content-Type": "application/json" };

    // If data is FormData, let Axios automatically set the correct headers
    if (data instanceof FormData) {
      delete (headers as Record<string, string>)["Content-Type"];
    }

    return {
      method,
      url,
      data,
      headers,
    };
  };

  request(options: any) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then(res => resolve(res.data))
        .catch(ex => reject(ex.response?.data || ex.message));
    });
  }
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");

  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, APIClientWithoutToken, setAuthorization, getLoggedinUser };
